<template>
  <div>
    <NavBar/>
    <div class="content-container">
      <div class="list-container">
        <!-- 搜索 -->
        <el-form
          :inline="true"
          :model="search"
          class="demo-form-inline"
        >
          <div class="search">
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="推广位PID">
                        <el-input v-model="search.pid"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="订单编号">
                        <el-input v-model="search.orderSn"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <!-- <el-form-item label="产品名称">
                        <el-input v-model="search.appCode"></el-input>
                    </el-form-item> -->
                    <el-form-item label="产品类型">
                        <el-select
                            v-model="search.appCode"
                            placeholder="请选择"
                        >
                            <el-option
                            v-for="item in productList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item> 
                </el-col>
                <el-col :span="6">
                    <el-form-item label="订单状态">
                        <el-select
                            v-model="search.orderSubStatusName"
                            placeholder="请选择"
                        >
                            <el-option
                            v-for="item in statuList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>                   
                </el-col>
                <el-col :span="10">
                    <el-form-item label="订单时间">
                        <el-date-picker 
                        type="daterange"
                         range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" 
                         v-model="search.orderTime" 
                         value-format="yyyy-MM-dd"
                         :picker-options="pickerOptions"
                         style="width: 100%;"></el-date-picker>
                    </el-form-item> 
                </el-col>
                <el-col :span="8">                  
                &nbsp;
                </el-col>
                <el-col :span="6">
                    <el-form-item style="text-align: right">
                    <el-button
                        type="primary"
                        @click="queryData"
                        style="margin-right:8px"
                    >搜索
                    </el-button>
                    <el-button @click="resetSearch">重置</el-button>
                    </el-form-item>                 
                </el-col>
            </el-row>
            
          </div>
        </el-form>
        <div class="table-total">
            <span>合计：</span>
            <span class="total-title">预估总佣金</span>
            <span class="total-money">{{moneyTrans(totalMoney)}}</span>
        </div>
        <!-- 投放数据 -->
        <!-- 数据列表 -->
        <el-table
          :key="tableKey"
          ref="multipleTable"
          v-loading="listLoading"
          stripe
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          :height="tableHeight"
        >
          <!-- <el-table-column
            label="序号"
            type="index"
            width="55"
          >
          </el-table-column> -->
          <el-table-column
            :show-overflow-tooltip="true"
            label="订单编号"
            min-width="100px"
          >
            <template slot-scope="scope">{{
                emptyDeal(scope.row.orderSn)
              }}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            label="订单状态"
            min-width="100px"
          >
            <template slot-scope="scope">{{
                emptyDeal(scope.row.orderSubStatusName)
              }}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            label="订单完结状态"
            min-width="100px"
          >
            <template slot-scope="scope">{{
                orderStatusTrans(scope.row.status)
              }}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            label="预估佣金"
            min-width="100px"
          >
            <template slot-scope="scope">{{
                moneyTrans(scope.row.commission)
              }}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            label="订单金额"
            min-width="100px"
          >
            <template slot-scope="scope">{{
                moneyTrans(scope.row.totalCost)
              }}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            label="客户类型"
            min-width="100px"
          >
            <template slot-scope="scope">{{
                custmerTrans(scope.row.newCustomer)
              }}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            label="订单创建时间"
            min-width="120px"
          >
            <template slot-scope="scope">{{
                formatDateTrans(scope.row.orderTime)
              }}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            label="订单更新时间"
            min-width="120px"
          >
            <template slot-scope="scope">{{
              formatDateTrans(scope.row.lastUpdateTime)
              }}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            width="160px"
            label="订单明细"
          >
            <template slot-scope="scope">
              <div class="icon-table-handle">
                <el-button
                  type="text"
                  @click="goDetail(scope.row.detailList)"
                >
                  详情
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="mt10">
          <el-pagination
            :key="pageInfo.currentPage"
            :current-page="pageInfo.currentPage"
            :page-size="pageInfo.limit"
            layout="total,sizes, prev, pager, next"
            :total="pageInfo.allCount"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
        <!-- 详情 -->
        <template>
          <div v-if="dialogDetail">
            <Detail
              :detaillist="detailList"
              @close="handleClose"
              :data="detailData"
              :showTotal="total"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from "@/components/navBar";
import {cpsDatahList, estimateDetail} from "@/api/launch";
import {timestampToTime} from "@/utils/date.js"
import {
  emptyTrans,
  formatMoney,
  formatDate,
  statusTrans
} from "@/api/dataTrans.js";
import Detail from "./components/detail.vue";
import Setting from "@/settings.js";

var {pageConfig} = Setting;
export default {
  components: {Detail, NavBar},
  data() {
    return {
      totalMoney:null,
      search: {
        pid: null,
        orderSn: null,
        appCode:"VIP",
        orderSubStatusName:null,
        orderTime:[]
      },
      dialogDetail: false,
      statuList: [
        {name: "请选择", id: null},
        {name: "已下单", id: "已下单"},
        {name: "已付款", id: "已付款"},
        {name: "已签收", id: "已签收"},
        {name: "待结算", id: "待结算"},
        {name: "已结算", id: "已结算"},
        {name: "已失效", id: "已失效"}
      ],
      productList:[
        {name: "请选择", id: null},
        {name: "唯品会", id: "VIP"}
      ],
      list: [],
      tableKey: 0,
      pageInfo: {
        limit: pageConfig["limit"],
        allCount: 0,
        currentPage: 1,
        currentPageCount: 0,
        showEdit: false // 是否显示快捷编辑代码框
      },
      tableHeight: document.body.clientHeight - 400,
      listLoading: false,
      detailData: {},
      total: {},
      timeDefaultShow:"",
      detailList: [], // 订单详情
    };
  },
  computed: {
  pickerOptions(){
    let _this = this
    return {
      disabledDate(time) {
        const times =  86400000 * 7
      return time.getTime() > Date.now() || time.getTime() < Date.now()-times 
      },
    }
  }
},
  mounted() {
    //设置默认时间
    this.getDate();
    this.getList();
    window.onresize = function () {
      this.tableHeight = document.body.clientHeight - 400;
    };
  },
  methods: {
    formatDateTrans(_val){
       return timestampToTime(_val);
    },
    orderStatusTrans(_val){
      let _result="待定";
      if(_val=='2'){
        _result="已完结"
      }else if(_val=='0'){
        _result="不合格"
      }
      return _result;
    },
    custmerTrans(_val){
      let _result="待定";
      if(_val=='1'){
        _result="新客"
      }else if(_val=='2'){
        _result="老客"
      }
      return _result;
    },
    status(val) {
      return statusTrans(val, this.statuList);
    },
    //默认获取当前时间
    getDate(){
      let _dateTmp=new Date()
      let dataStr=_dateTmp.getFullYear()+"-"+(_dateTmp.getMonth()+1)+"-"+_dateTmp.getDate()
    this.search.orderTime=[dataStr,dataStr]
    },
    getList() {
      var pramaList = {};
      pramaList = JSON.parse(JSON.stringify(this.search));
      delete pramaList.orderTime
      // debugger
      cpsDatahList({
        pageIndex: this.pageInfo.currentPage,
        pageSize: this.pageInfo.limit,
        orderTimeBegin:this.search.orderTime[0]+' 00:00:00',
        orderTimeEnd:this.search.orderTime[1]+' 23:59:59',
        ...pramaList
      }).then(res => {
        if (res && res.code == 0) {
          this.list = res.data.data;
          this.totalMoney=res.data.commissionCount
          this.pageInfo.allCount = res.data.num;
        }
      });
    },
    queryData() {
      this.pageInfo.currentPage = 1;
      this.getList();
    },
    resetSearch(formName) {
      this.search = this.$options.data().search;
      this.getDate();
      this.getList();
    },
    goDetail(val) {
      this.detailList = val;
      this.dialogDetail = true;
      // this.getDetail(val);
    },
    // 显示隐藏操作按钮
    operateShow(row, column, cell, event) {
      event.path[1].cells[6].children[0].children[0].style.display = "block";
    },
    operateClose() {
      event.path[1].cells[6].children[0].children[0].style.display = "none";
    },
    handleSizeChange(val) {
      this.pageInfo.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val;
      this.getList();
    },
    emptyDeal(_val) {
      return emptyTrans(_val);
    },
    handleClose() {
      this.dialogDetail = false;
      this.detailList = [];
      this.getList();
    },
    moneyTrans(_val) {
      return formatMoney(_val);
    }
  }
};
</script>
<style scoped lang="scss">
/deep/ .el-form-item__label {
  text-align: left;
}

/deep/ .el-input {
  width: 100%;
}

/deep/ .el-select {
  width: 100%;
}

/deep/ .el-form-item {
  margin-bottom: 16px;
}

.icon {
  display: none;
  text-align: center;
}

/deep/ .el-form-item__label {
  text-align: right;
}

.iconfont {
  display: none;
}

/deep/ .el-form-item {
  width: 90%;
  margin-bottom: 22px;
}

.list-container {
  background-color: #fff;
  padding: 24px;
}
.table-total{
    padding:8px;background-color:rgba(19,194,194,0.05);color:rgba(0,0,0,0.65);font-size:12px;margin-bottom:16px;
}
.table-total .total-title{
    margin:0px 5px 24px;    
}
.table-total .total-money{
    color:#13c2c2;
}
</style>
